import { h, Host } from "@stencil/core";
import { getUniqueId } from "../../utils/unique-id";
const referenceAttr = "data-reference";
const removeAllSelector = ".ux-filter__remove-all";
export class Filter {
    constructor() {
        this.endpoint = undefined;
        this.filterValues = undefined;
    }
    domNode;
    /** the HTML Element containing the tag list */
    tagList = null;
    tagRemovedHandler(event) {
        const checkbox = this.domNode.querySelector(`input[type="checkbox"][${referenceAttr}="${event.detail}"]`);
        if (checkbox !== null) {
            this.uncheck(checkbox);
            this.filterChange.emit();
            this.updateRemoveAll();
        }
    }
    /** is triggered when any input inside the filter was changed */
    filterChange;
    onSubmit = (e) => {
        e.preventDefault();
    };
    onChange = (e) => {
        const checkbox = e.target;
        if (e instanceof CustomEvent && e.detail?.isFilterUncheck) {
            return;
        }
        if (checkbox.matches('input[type="checkbox"]')) {
            if (checkbox.matches(`:not(:checked)[${referenceAttr}]`)) {
                const reference = checkbox.getAttribute(referenceAttr);
                const tags = this.domNode.querySelectorAll(`ux-tag[reference="${reference}"]`);
                [].forEach.call(tags, (tag) => tag.remove());
            }
            else {
                this.addTag(checkbox);
            }
        }
        this.filterChange.emit(e);
        this.updateRemoveAll();
    };
    uncheck(checkbox) {
        checkbox.checked = false;
        checkbox.dispatchEvent(new CustomEvent("change", { detail: { isFilterUncheck: true } }));
    }
    addTag(checkbox) {
        const reference = getUniqueId();
        checkbox.setAttribute(referenceAttr, reference);
        if (this.tagList === null) {
            return;
        }
        // @ts-expect-error Check for typing
        const labelText = checkbox.closest("label").innerText.replace(/^[\s]+/, "");
        const tag = document.createElement("ux-tag");
        tag.setAttribute("reference", reference);
        tag.setAttribute("removable", "true");
        tag.innerText = labelText;
        this.tagList.appendChild(tag);
    }
    updateRemoveAll() {
        const btnRemoveAll = this.domNode.querySelector(removeAllSelector);
        if (btnRemoveAll === null) {
            return;
        }
        setTimeout(() => {
            const activeFilters = this.domNode.querySelectorAll(`input[type="checkbox"][${referenceAttr}]:checked`);
            if (activeFilters.length > 0) {
                btnRemoveAll.classList.remove("is-hidden");
            }
            else if (!btnRemoveAll.classList.contains("is-hidden")) {
                btnRemoveAll.classList.add("is-hidden");
            }
        }, 1);
    }
    removeAllFilters() {
        const checkboxes = this.domNode.querySelectorAll(`input[type="checkbox"][${referenceAttr}]:checked`);
        [].forEach.call(checkboxes, this.uncheck);
        if (this.tagList !== null) {
            const tags = this.tagList.querySelectorAll("ux-tag[reference]");
            [].forEach.call(tags, (tag) => tag.remove());
        }
        this.filterChange.emit();
        this.updateRemoveAll();
    }
    handleTagListVisibility = () => {
        if (this.tagList === null) {
            return;
        }
        if (this.tagList.querySelector("ux-tag") === null) {
            this.tagList.classList.add("is-hidden");
        }
        else {
            this.tagList.classList.remove("is-hidden");
        }
    };
    tagListObserver = new MutationObserver(this.handleTagListVisibility);
    componentDidLoad() {
        this.tagList = this.domNode.querySelector(".ux-tag-list");
        if (this.tagList !== null) {
            this.handleTagListVisibility();
            this.tagListObserver.observe(this.tagList, {
                childList: true
            });
        }
        this.initFilters();
        this.initSlot();
    }
    initFilters() {
        if (typeof this.endpoint !== "string" || this.endpoint === "") {
            // TODO: uninit/reset
            return;
        }
        fetch(this.endpoint)
            .then((r) => r.json())
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            .then((response) => {
            this.filterValues = response.filterValues;
            this.domNode.querySelectorAll("ux-dropdown").forEach((item) => {
                if (item.matches("[name]")) {
                    // @ts-expect-error Check for typing
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    new Array(response.filterValues[item.getAttribute("name")]).forEach((filterValuesInfo) => {
                        // @ts-expect-error Check for typing
                        item.querySelector("ux-list").setFilterValues(filterValuesInfo);
                    });
                }
            });
        });
    }
    initSlot() {
        // check if web components in slot are correctly loaded
        // this is a workaround because of this bug: https://github.com/ionic-team/stencil/issues/1130
        if (this.domNode.querySelector(`ux-checkbox:not(.hydrated), ux-checkbox-list-item:not(.hydrated)`) !== null) {
            window.setTimeout(() => this.initSlot(), 50);
            return;
        }
        // init checkboxes that are checked at load
        const checkedCheckboxes = this.domNode.querySelectorAll(`input[type="checkbox"]:checked`);
        [].forEach.call(checkedCheckboxes, (checkbox) => this.addTag(checkbox));
        // connect remove all filters button
        const btnRemoveAll = this.domNode.querySelector(removeAllSelector);
        if (btnRemoveAll !== null) {
            // @ts-expect-error Check for typing
            btnRemoveAll.addEventListener("click", (event) => {
                event.preventDefault();
                this.removeAllFilters();
            });
            this.updateRemoveAll();
        }
    }
    render() {
        return (h(Host, { key: '207dc2f4b605f0aafc000aec73082c4ffcfa258d', class: "ux-filter" }, h("form", { key: 'bb44c5740efc94ff972a90b91d98aed3b442a4bd', onSubmit: this.onSubmit, onChange: this.onChange }, h("slot", { key: '0c649bdf0731701f3bcaf050ea55e3c3fc2d8500' }))));
    }
    static get is() { return "ux-filter"; }
    static get originalStyleUrls() {
        return {
            "$": ["filter.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["filter.css"]
        };
    }
    static get properties() {
        return {
            "endpoint": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is a URL to a JSON API."
                },
                "attribute": "endpoint",
                "reflect": true
            }
        };
    }
    static get states() {
        return {
            "filterValues": {}
        };
    }
    static get events() {
        return [{
                "method": "filterChange",
                "name": "uxFilterChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "is triggered when any input inside the filter was changed"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "endpoint",
                "methodName": "initFilters"
            }];
    }
    static get listeners() {
        return [{
                "name": "uxRemove",
                "method": "tagRemovedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=filter.js.map
